function Footer() {
    return (
        <>
            <div className="footer--icons">
                <a href="https://github.com/JacksonDynamics">
                    <i class="fa-brands fa-github fa-3x"></i>
                </a>
                <a href="https://www.linkedin.com/in/brendon-jackson/">
                    <i class="fa-brands fa-linkedin fa-3x"></i>
                </a>
                <a href="https://dev.to/jacksondynamics">
                    <i class="fa-brands fa-dev fa-3x"></i>
                </a>
            </div>
        </>
    )

}

export default Footer